"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_brand_1 = require("@giphy/js-brand");
var emotion_1 = require("emotion");
var preact_1 = require("preact");
// trying to share css from brand, but this has an element structure
// so it's ugly. will probably move the css in here
exports.default = (function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return (preact_1.h("div", { className: emotion_1.cx(js_brand_1.loader, className) },
        preact_1.h("div", null),
        preact_1.h("div", null),
        preact_1.h("div", null),
        preact_1.h("div", null),
        preact_1.h("div", null)));
});
//# sourceMappingURL=loader.js.map